<section *ngIf="isAvailable" class="external-links-pad">
  <section class="pt-menu-example-row">
    <div [dlsMenuTriggerFor]="external_links_menu" class="external-links-icon-wrapper">
      <span class="icon__LinkExternal external-links-icon pointer" [dlsTooltip]="'External Links'"
            [tooltipPosition]="'Bottom'"
            [tooltipClass]="'pt-primary'"
            [tooltipShowDelay]="1"
            [tooltipHideDelay]="10"></span>
    </div>
  </section>

  <dls-menu #external_links_menu (change)="openLink($event)">
    <div class="menu-title-wrapper">
      <dls-menu-item disabled="true">
        <span class="menu-title">External Links</span>
      </dls-menu-item>
      <dls-menu-item class="menu-close-icon-wrapper">
        <dls-icon class="icon__close menu-close-icon"></dls-icon>
      </dls-menu-item>
    </div>

    <hr class="pt-separator menu-title-separator"/>

    <div *ngFor="let link of links">
      <div class="menu-content">
        <dls-menu-item [value]="link.linkTitle">
          <label>{{link.linkTitle}}</label>
        </dls-menu-item>
        <hr/>
      </div>
    </div>
  </dls-menu>
</section>

